window.app.factory("setupSearch", [
  "$rootScope",
  "$state",
  "$timeout",
  function($rootScope, $state, $timeout) {
    return function setupSearch() {
      // App-wide search
      $rootScope.doSearch = function(showPrompt) {
        const q = showPrompt
          ? prompt("Type to search", $rootScope.searchQuery || "")
          : $rootScope.searchQuery;
        if (q) {
          $rootScope.searchQuery = q.trim();
          $state.go("search-async", { query: $rootScope.searchQuery });
          document.querySelector(".searchbox input").blur();
          $rootScope._showMobileSearch = false;
          window.gtag("event", "search", {
            event_label: $rootScope.searchQuery
          });
        }
      };

      $rootScope.toggleMobileSearch = function(setTo) {
        const v = setTo !== undefined ? setTo : !$rootScope._showMobileSearch;
        $timeout(() => {
          console.warn("Setting to", v);
          $rootScope._showMobileSearch = v;
          if (v) {
            setTimeout(() => {
              document.querySelector(".searchbox input").focus();
            }, 400);
          }
        }, 0);
      };

      $rootScope.shouldShowMobileSearch = function() {
        return window.isMobile && $rootScope._showMobileSearch;
      };
    };
  }
]);



// WEBPACK FOOTER //
// ./src/helpers/setupSearch.js